module.exports = __webpack_public_path__ + "img/neudorf-menu.2a1a6a8e.webp";